<div class="layout-topbar">
    <div class="layout-topbar-start">
        <a class="layout-topbar-logo" routerLink="/">
            <img src="assets/layout/images/logo-sgmao.jpg" alt="SGMAO"
                class="layout-topbar-logo-full" style="height:36px;border-radius:6px" />
            <img src="assets/layout/images/logo-sgmao.jpg" alt="SGMAO"
                class="layout-topbar-logo-slim" style="height:32px;border-radius:6px" />
        </a>
        <a #menuButton class="layout-menu-button" (click)="onMenuButtonClick()" pRipple>
            <i class="pi pi-chevron-right"></i>
        </a>

        <a #mobileMenuButton class="layout-topbar-mobile-button" (click)="onMobileTopbarMenuButtonClick()" pRipple>
            <i class="pi pi-ellipsis-v"></i>
        </a>
    </div>

    <div class="layout-topbar-end">
        <div class="layout-topbar-actions-start flex align-items-center gap-2 text-white">
            <span class="font-semibold text-sm opacity-80">{{ structureName }}</span>

            <!-- Sélecteur d'entreprise -->
            <p-dropdown [options]="structures" optionLabel="nom" optionValue="id" [(ngModel)]="selectedStructure"
                placeholder="Changer d'entreprise" [style]="{width: '220px'}"></p-dropdown>

            <!-- Bouton Recharger : icône seule -->
            <button pButton type="button" icon="pi pi-refresh" pTooltip="Recharger"
                class="p-button-sm p-button-rounded p-button-outlined text-white border-white"
                (click)="rechargerStructure()"></button>
        </div>

        <div class="layout-topbar-actions-end">
            <ul class="layout-topbar-items">

                <!-- Notifications -->
                <li>
                    <a pStyleClass="@next" enterFromClass="ng-hidden" enterActiveClass="px-scalein"
                        leaveToClass="ng-hidden" leaveActiveClass="px-fadeout" [hideOnOutsideClick]="true" pRipple>
                        <i class="pi pi-bell" pBadge [value]="notificationsBadge"
                            severity="warning"></i>
                    </a>
                    <div class="ng-hidden" style="min-width:320px">
                        <div class="px-3 py-2 border-bottom-1 surface-border flex align-items-center justify-content-between">
                            <span class="font-semibold">Notifications</span>
                            <span class="text-xs text-500">{{ notifications.length }} non lue(s)</span>
                        </div>
                        <ul class="list-none p-0 m-0" style="max-height:300px;overflow-y:auto">
                            <li *ngIf="notifications.length === 0" class="px-3 py-3 text-500 text-sm text-center">
                                Aucune nouvelle notification
                            </li>
                            <li class="px-3 py-2 cursor-pointer hover:surface-hover border-bottom-1 surface-border"
                                *ngFor="let item of notifications" (click)="updateNotification(item)">
                                <div class="flex flex-column gap-1">
                                    <span class="font-semibold text-sm">{{ item.sujet }}</span>
                                    <span class="text-xs text-500 line-height-3">{{ item.message }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li>

                <!-- Avatar + menu utilisateur -->
                <li>
                    <a pStyleClass="@next" enterFromClass="ng-hidden" enterActiveClass="px-scalein"
                        leaveToClass="ng-hidden" leaveActiveClass="px-fadeout" [hideOnOutsideClick]="true" pRipple
                        class="flex align-items-center gap-2 cursor-pointer">
                        <img *ngIf="currentUser?.photoProfile && !photoLoadError" [src]="urlPhotoProfil" alt="avatar"
                            class="w-2rem h-2rem border-circle" style="object-fit:cover"
                            (error)="photoLoadError = true">
                        <span *ngIf="!currentUser?.photoProfile || photoLoadError"
                            class="w-2rem h-2rem border-circle bg-primary-400 text-white flex align-items-center justify-content-center font-bold text-sm flex-shrink-0">
                            {{ topbarInitiales }}
                        </span>
                        <span class="text-white text-sm font-medium hidden md:block">
                            {{ currentUser?.prenom }} {{ currentUser?.nom }}
                        </span>
                        <i class="pi pi-angle-down text-white text-xs hidden md:block"></i>
                    </a>
                    <div class="ng-hidden" style="min-width:200px">
                        <div class="px-3 py-2 border-bottom-1 surface-border">
                            <span class="font-semibold text-sm block">{{ currentUser?.prenom }} {{ currentUser?.nom }}</span>
                            <span class="text-xs text-500">{{ currentUser?.email }}</span>
                        </div>
                        <ul class="list-none p-0 m-0">
                            <li>
                                <a class="cursor-pointer flex align-items-center gap-2 px-3 py-2 hover:surface-hover transition-duration-150"
                                    pRipple routerLink="/dashboard/profile">
                                    <i class="pi pi-user text-primary"></i>
                                    <span class="text-sm">Mon profil</span>
                                </a>
                            </li>
                            <li class="border-top-1 surface-border">
                                <a class="cursor-pointer flex align-items-center gap-2 px-3 py-2 hover:surface-hover transition-duration-150 text-red-500"
                                    pRipple (click)="logout()">
                                    <i class="pi pi-power-off"></i>
                                    <span class="text-sm">Déconnexion</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>

            </ul>
        </div>
    </div>
</div>
